import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AccountLevel4Response } from 'src/app/models/account.model';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { CategoryVendorResponse } from 'src/app/models/category.model';
import { InputAutocompleteModel } from 'src/app/models/input-autocomplete.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { CategoryAccountRequest } from 'src/app/models/vendor.model';
import { AccountService } from 'src/app/services/account.service';
import { VendorService } from 'src/app/services/vendor.service';

@Component({
  selector: 'app-modal-expense-category',
  templateUrl: './modal-expense-category.component.html',
  styleUrls: ['./modal-expense-category.component.scss']
})
export class ModalExpenseCategoryComponent implements OnInit {
  buttonSave: ButtonLoading = new ButtonLoading("btn-success", false, "GUARDAR", "fa-save");
  @Output() close = new EventEmitter<any>();
  @Input() edit: CategoryVendorResponse = null;
  name = "";
  accountId = null;
  accounts = new InputAutocompleteModel("", false, true, "", "", "", "", null, []);
  @Input() allAccounts: AccountLevel4Response[] = [];
  timeout = null;

  constructor(
    private toastService: ToastrService,
    private accountService: AccountService,
    private vendorService: VendorService
  ) {

  }

  ngOnInit(): void {
    if (this.edit) {
      this.accountId = this.edit.accountId;
      this.name = this.edit.name;
    }
    if (this.allAccounts.length == 0) {
      this.getAccounts();
    } else {
      this.accounts.filterElements = this.allAccounts;
      this.selectForEdit();
    }
  }

  writeAccount() {
    clearTimeout(this.timeout);
    this.accounts.verified = false;
    this.accounts.data = null;
    this.accountId = null;
    this.accounts.class = "typing";
    this.timeout = setTimeout(() => {
      var low = this.accounts.value.toLowerCase();
      this.accounts.filterElements = this.allAccounts.filter((a) => {
        var tempDis = a.displayId.replace(/\./g, "");
        return a.displayId.toLowerCase().includes(low) || a.name.toLowerCase().includes(low) || tempDis.toLowerCase().includes(low)
      });
      if (this.accounts.filterElements.length == 0) {
        this.accounts.class = "fa-xmark";
      } else {
        this.accounts.class = "fa-list";
      }
    }, 200);
  }

  selectAccount(account) {
    this.accounts.value = account.name;
    this.accounts.class = "fa-circle-check";
    this.accounts.verified = true;
    this.accounts.data = account;
    this.accountId = account.id;
  }

  selectForEdit() {
    if (this.accountId) {
      var found = this.allAccounts.find((a) => a.id == this.accountId);
      if (found) {
        this.accounts.value = found.name;
        this.accounts.class = "fa-circle-check";
        this.accounts.verified = true;
        this.accounts.data = found;
      }
    }
  }

  getAccounts() {
    this.accountService.getAccountsLevel4().subscribe({
      next: (response: ResponseObject) => {
        this.allAccounts = response.data;
        this.accounts.filterElements = this.allAccounts;
        this.selectForEdit();
      },
      error: (error) => {
        this.toastService.error("Error al obtener las cuentas");
      }
    })
  }

  createOrEdit(){
    if (this.buttonSave.loading) {
      return;
    }
    this.buttonSave.loading = true;
    if (this.edit) {
      let request = Object.assign({}, this.edit);
      request.accountId = this.accountId;
      request.name = this.name;
      this.vendorService.editCategoryVendor(request).subscribe({
        next: (response: ResponseObject) => {
          this.buttonSave.loading = false;
          this.toastService.success("Categoria editada exitosamente!");
          this.close.emit(request);
        },
        error: (error) => {
          this.buttonSave.loading = false;
          this.toastService.error("Error al editar la categoria");
        }
      })
    } else {
      let request = new CategoryAccountRequest();
      request.accountId = this.accountId;
      request.name = this.name;
      this.vendorService.createCategoryAccountVendor(request).subscribe({
        next: (response: ResponseObject) => {
          this.buttonSave.loading = false;
          this.toastService.success("Categoria creada exitosamente!");
          this.close.emit(request);
        },
        error: (error) => {
          this.buttonSave.loading = false;
          this.toastService.error("Error al crear la categoria");
        }
      })
    }
  }
}
